module.exports = __webpack_public_path__ + "static/media/motic  design.c456148e.png";